// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DeZl","newExpiryDate":"styles_newExpiryDate__3cJMz","footer":"styles_footer__Rb3kK"};